export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10094.16133990.jpg";